import * as React from 'react';
import { Labels } from '../../styled/blog';
import { LangLink } from '../lang-link';

type Props = {
  tags: string[];
};

const Tags = ({ tags }: Props) => (
  <Labels>
    {tags.map((tag, i) => (
      <li key={i}><LangLink to={`/blog/tags/${tag}`}>#{tag}</LangLink></li>
    ))}
  </Labels>
);

export default Tags;
